/**
 * Change Header on scroll
 * 
 * @return {Void}      
 */

$(window).on('scroll', function(evt) {
	const scrollPos = $(this).scrollTop();

	if (scrollPos > 0) {
		$('.js-header').addClass('is-active');
		return;
	}

	$('.js-header').removeClass('is-active');
});
